import React, { useCallback, useEffect, useState } from 'react';
import { Col, Container, ListGroupItem, Navbar, NavDropdown, Row, Alert } from "react-bootstrap";
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { detail, logout } from '../actions/userActions';
import { listCategories } from '../actions/categoryActions';
import { userDetailsReset, userLogoutReset, userSliceReset } from '../reducers/userReducers';
import { buyList } from '../actions/orderActions';
import { orderReset } from '../reducers/orderReducers';
import { LinkContainer } from 'react-router-bootstrap';
import { Nav } from 'react-bootstrap';
import { FaShoppingCart, FaUser, FaBullhorn } from 'react-icons/fa';
import { fetchAnnouncements } from '../actions/announcementActions';
import { COLORS } from '../constants/colors';

function Header() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const {
        announcementReducers: { announcements = [], loading: announcementsLoading, error: announcementsError },
        userReducers: { user, userLogoutSuccess, userInfo, userDetailsSuccess, userLogoutError },
        orderReducers: { buyOrders, buyOrderError }
    } = useSelector((state) => state);
    
    const [currentAnnouncement, setCurrentAnnouncement] = useState(0);
    
    const plum = COLORS.PLUM;
    const sageGreen = COLORS.SAGE_GREEN;
    const warmConcrete = COLORS.WARM_CONCRETE;
    
    // Reset announcement index when announcements change
    useEffect(() => {
        if (announcements && announcements.length > 0) {
            setCurrentAnnouncement(0);
        }
    }, [announcements, announcementsLoading, announcementsError]);
    
    // Fetch announcements from API
    useEffect(() => {
        dispatch(fetchAnnouncements());
    }, [dispatch]);
    
    // Rotate through announcements every 5 seconds
    useEffect(() => {
        if (announcements && announcements.length > 0) {
            const interval = setInterval(() => {
                setCurrentAnnouncement(prev => (prev + 1) % announcements.length);
            }, 5000);
            
            return () => clearInterval(interval);
        }
    }, [announcements]);

    const logoutAndClean = useCallback(() => {
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        dispatch(logout());
    }, [dispatch]);

    const logoutHandler = () => {
        dispatch(userSliceReset());
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        document.cookie.split(";").forEach(function(c) {
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;domain=.pigeonauction.co.za");
        });
        dispatch(logout());
        navigate('/categories/AUCTIONS-c-4');
    };

    useEffect(() => {
        dispatch(listCategories());
    }, [dispatch]);

    useEffect(() => {
        if(!user && userInfo) {
            dispatch(detail());
        }

        if(user) {
            dispatch(buyList());
        }
    }, [dispatch, user, userInfo, navigate]);

    useEffect(() => {
        if(buyOrderError) {
            logoutAndClean();
            dispatch(orderReset());
        }
    }, [dispatch, buyOrderError, logoutAndClean]);

    useEffect(() => {
        if(userDetailsSuccess) {
            dispatch(userDetailsReset());
        }
    }, [dispatch, userDetailsSuccess]);

    useEffect(() => {
        if(userLogoutSuccess) {
            dispatch(userLogoutReset());
        } else if(userLogoutError) {
            dispatch(userLogoutReset());
        }
    }, [userLogoutSuccess, userLogoutError, dispatch]);

    useEffect(() => {
        if (window.location.pathname === '/') {
            navigate('/categories/AUCTIONS-c-4');
        }
    }, [navigate]);

    const navLinkClass = "nav-link px-2";

    if (announcements && announcements.length > 0 && currentAnnouncement >= announcements.length) {
        setCurrentAnnouncement(0);
    }

    return (
        <div className="header-wrapper">
        {announcementsLoading ? (
            <div className="text-center p-1 bg-light">Loading announcements...</div>
        ) : announcementsError ? (
            <div className="text-center p-1 bg-danger text-white">Error: {announcementsError}</div>
        ) : announcements && announcements.length > 0 ? (
            <Alert 
                variant="warning" 
                className="mb-0 py-2 text-center" 
                style={{ 
                    backgroundColor: announcements[currentAnnouncement]?.bg_color || warmConcrete, 
                    color: announcements[currentAnnouncement]?.text_color || plum,
                    borderRadius: 0, 
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color 0.5s ease, color 0.5s ease'
                }}
                onClick={() => navigate(announcements[currentAnnouncement]?.link || '/categories/AUCTIONS-c-4')}
            >
                <div className="d-flex align-items-center justify-content-center">
                    <FaBullhorn className="me-2" style={{ fontSize: '1.5rem' }} />
                    <strong>{announcements[currentAnnouncement]?.text}</strong>
                </div>
            </Alert>
        ) : null}
        
        <header style={{ 
            backgroundColor: warmConcrete,
            borderBottom: `1px solid ${sageGreen}`,
            boxShadow: `0 2px 4px rgba(168, 187, 162, 0.3)`
        }}>
            <Container>
                <Row className='align-items-center'>
                    <Col xs={12} md={3} className='text-center text-md-start mb-3 mb-md-0'>
                        <NavLink to='/categories/AUCTIONS-c-4' className={'nav-link link-dark d-flex flex-column align-items-center'}>
                            <Navbar.Brand className='fw-semibold d-flex flex-column align-items-center'>
                                <img
                                    src="https://pigeonauction.co.za/images/logo.png"
                                    alt="Logo"
                                    style={{
                                        height: '75px',
                                    }}
                                />
                            </Navbar.Brand>
                        </NavLink>
                    </Col>

                    <Col xs={12} md={6} className='text-center mb-3 mb-md-0'>
                        
                    </Col>

                    <Col xs={12} md={3} className='d-flex flex-column align-items-center justify-content-center'>
                        <div className='d-flex align-items-center justify-content-center'>
                            {user ? (
                                <>
                                    <ListGroupItem className='me-2'>
                                        <NavLink to={'/shopping-cart'}
                                            className={({isActive, isPending}) =>
                                                isPending ? "" : isActive ? `${navLinkClass} d-flex link-secondary mt-1` : `${navLinkClass} d-flex link-dark mt-1`
                                            }
                                        >
                                            {buyOrders && buyOrders.length > 0 ? (
                                                <>
                                                    <FaShoppingCart size={20} />
                                                    <Col className='cart-item-count ms-1'>
                                                        {buyOrders.length}
                                                    </Col>
                                                </>
                                            ) : (
                                                <>
                                                   
                                                </>
                                            )}
                                        </NavLink>
                                    </ListGroupItem>
                                    <NavDropdown title={user ? (
                                        <>
                                            <i className="fa-solid fa-user" style={{ color: plum }}></i> <span style={{ color: plum }}>{user.name}</span>
                                        </>
                                    ) : 'Please set your account.'} id='username'>
                                        <NavDropdown.Item onClick={() => navigate('/profile')}>
                                            Profile
                                        </NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item onClick={logoutHandler} style={{ color: plum }}>
                                            Logout
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>
                            ) : (
                                <LinkContainer to='/login'>
                                    <Nav.Link style={{ color: plum }}><FaUser size={20} color={plum} /> Sign In</Nav.Link>
                                </LinkContainer>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </header>
        </div>
    );
}

export default Header;
